import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import React from 'react';

const ReportPage = () => {
  const { appName } = useAppName();
  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title={PAGES[appName]?.report?.title || ''}
          description={PAGES[appName]?.report?.description || ''}
        />
        {/* <TableCompetencyManagement /> */}
      </Stack>
    </Container>
  );
};

export default ReportPage;
